import Popup from 'semantic-ui-react/dist/es/modules/Popup'

const legacyOffset = (horizontalOffset, verticalOffset) => {
  if (!horizontalOffset && !verticalOffset) return undefined
  return [horizontalOffset ? -horizontalOffset : 0, verticalOffset || 0]
}

export default function ImprovedPopup({
  horizontalOffset,
  offset,
  scrollNode, // SUIR v3 handles scroll positioning; strip legacy-only prop.
  verticalOffset,
  ...props
}) {
  return (
    <Popup
      {...props}
      offset={offset || legacyOffset(horizontalOffset, verticalOffset)}
    />
  )
}
